/**
 * AI 계약서 초안 자동생성 API — tech_spec.md 8-1절
 */
import axios from 'axios';
import { API_ORIGIN } from '../config/runtime';

const client = axios.create({ baseURL: `${API_ORIGIN}/api/contract-ai`, timeout: 60000 });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface ContractDraftExtracted {
  clientName: string;
  freelancerName: string;
  projectTitle: string;
  scopeOfWork: string;
  totalAmount: number | null;
  paymentSchedule: string;
  startDate: string | null;
  endDate: string | null;
  deliverables: string[];
  specialTerms: string[];
  confidence: { totalAmount: string; period: string; scope: string };
  needsReview: string[];
}

export interface ContractDraftTemplate {
  title: string;
  articles: { heading: string; body: string }[];
  disclaimer: string;
}

export const contractAiAPI = {
  generate: async (roomId: number) => {
    const res = await client.post('/generate', { roomId });
    return res.data as { success: boolean; message?: string; code?: string; data?: { draftId: number; extracted: ContractDraftExtracted; template: ContractDraftTemplate } };
  },
  getLatest: async (roomId: number) => {
    const res = await client.get(`/${roomId}`);
    return res.data as { success: boolean; data: { draftId: number; extracted: ContractDraftExtracted; template: ContractDraftTemplate; createdAt: string } | null };
  },
};

export default contractAiAPI;
